import React from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import NavigationBar from '../components/Navbar';
import Footer from '../components/Footer';
import EditableText from '../components/EditableText';
import { LanguageContext } from '../contexts/LanguageContext';
import { Helmet } from 'react-helmet';

const SetupSuccessPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { language } = React.useContext(LanguageContext);
  const location = useLocation() as any;
  const email: string | undefined = location?.state?.email;

  return (
    <div className='grips-bg d-flex flex-column min-vh-100'>
      <Helmet>
        <title>{language === 'de' ? 'Konfiguration gesendet' : 'Configuration submitted'}</title>
      </Helmet>
      <NavigationBar />
      <div className='container flex-grow-1 py-5 text-white'>
        <h1 className='mb-3'>{language === 'de' ? 'Vielen Dank!' : 'Thank you!'}</h1>
        <p className='lead'>
          {language === 'de' ? 'Ihre Konfiguration wurde erfolgreich übermittelt.' : 'Your configuration has been submitted successfully.'}
        </p>
        <div className='card bg-transparent border-light mb-4'>
          <div className='card-body'>
            <div className='mb-2 text-white-50'>{language === 'de' ? 'Ihre ID:' : 'Your ID:'}</div>
            <div className='display-6 text-white'>{id}</div>
          </div>
        </div>
        <div className='mb-4'>
          <EditableText id={language === 'de' ? '720' : '721'} />
          {!email ? null : (
            <p className='mt-2'>
              {language === 'de' ? `Eine Bestätigung wurde Ihnen per Mail an ${email} geschickt.` : `A confirmation email has been sent to ${email}.`}
            </p>
          )}
        </div>
        <div className='d-flex gap-2'>
          <Link to={`/setup/status/${id}`} className='btn btn-danger'>
            {language === 'de' ? 'Status ansehen' : 'View status'}
          </Link>
          <Link to='/' className='btn btn-outline-light'>
            {language === 'de' ? 'Zur Startseite' : 'Back to home'}
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SetupSuccessPage;
